import React from 'react';
import { HealthTreePricing } from '../components/ui/pricing-cards';

const Pricing: React.FC = () => {
  return <HealthTreePricing />;
};

export default Pricing; 